export default function TemplatesService($http, appSettings) {
  'ngInject';
  return {
    createTemplate: function (template) {
      if (!template) {
        return;
      }

      const endpoint = `${appSettings.InReachApiEndpoint}/templates`;
      return $http.post(endpoint, template);
    },
    updateTemplate: function (template) {
      if (!template) {
        return;
      }

      const endpoint = `${appSettings.InReachApiEndpoint}/template/${template.id}`;
      return $http.put(endpoint, template);
    },
    deleteRole: function (template) {
      if (!template) {
        return;
      }

      const endpoint = `${appSettings.InReachApiEndpoint}/template/${template.id}`;
      return $http.delete(endpoint, template);
    }
  };
}